import { render, staticRenderFns } from "./LugarGaleria.vue?vue&type=template&id=24b3cf17&scoped=true"
import script from "./LugarGaleria.vue?vue&type=script&lang=js"
export * from "./LugarGaleria.vue?vue&type=script&lang=js"
import style0 from "./LugarGaleria.vue?vue&type=style&index=0&id=24b3cf17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b3cf17",
  null
  
)

export default component.exports